<template>
  <div class="Upgrade">
    <img :src="iconUrl" alt="" class="Upgrade__Icon" />
    <span class="t5">
      {{ text }}
      <a class="link link--underline" :href="url">{{ title }}</a>
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  text: String,
  title: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
  iconUrl: String,
});
</script>
